module.exports = "/assets/data/18f106806d20e413da94866dbc4be315-CV36.data.json";